export const companyInfo = {
  name: "Wayne Iron Works",
  tagline: "Built Strong. Fabricated Right.",
  founded: "Established 1978",
  addressLine1: "1910 Turner Dr. Unit C",
  addressLine2: "Houston, TX 77093",
  country: "United States",
  phone: "+713-466-7322",
  email: "wayne.ironworks@gmail.com",
};

export const services = [
  {
    title: "Structural Steel Fabrication",
    description:
      "Shop-fabricated steel members produced to strict dimensional tolerances, coordinated for efficient field assembly and long-term structural performance.",
  },
  {
    title: "Commercial Steel Construction",
    description:
      "Steel packages for office, retail, healthcare, and institutional facilities with disciplined coordination, schedule reliability, and constructability focus.",
  },
  {
    title: "Custom Residential Steel",
    description:
      "Architectural and structural steel for high-value residential builds requiring precise detailing, clean finishes, and dependable installation support.",
  },
  {
    title: "Industrial Structural Projects",
    description:
      "Heavy-duty structural systems for plants, logistics facilities, and process environments where uptime, safety, and durability are non-negotiable.",
  },
  {
    title: "Miscellaneous Metals",
    description:
      "Ladders, stairs, rails, platforms, and support steel fabricated with practical field integration and compliance-ready documentation.",
  },
  {
    title: "Welding & Installation Support",
    description:
      "Certified welding and installation coordination to maintain quality standards from fabrication floor through final field execution.",
  },
];

export const featuredProjects = [
  {
    slug: "north-houston-logistics-frame",
    title: "North Houston Logistics Frame",
    sector: "Commercial Development",
    image:
      "https://static.prod-images.emergentagent.com/jobs/5995eb9b-583c-4baf-9d6a-d269b793de6b/images/235a1c00cec88bfca05fe7cc7014dd207138149d55506ef926c7ec4f0ceff346.png",
    overview:
      "A full structural steel package for a high-throughput logistics center requiring phased delivery and exact erection sequencing.",
    scope: [
      "Fabrication of primary and secondary framing members",
      "Connection detailing aligned with field erection constraints",
      "Sequenced shipment planning to support rolling construction windows",
    ],
    highlights: [
      "Maintained schedule continuity during active site operations",
      "Close coordination with GC and erection team reduced field rework",
      "Delivered precise steel geometry for accelerated envelope close-in",
    ],
  },
  {
    slug: "east-loop-industrial-upgrade",
    title: "East Loop Industrial Upgrade",
    sector: "Industrial Facility",
    image:
      "https://static.prod-images.emergentagent.com/jobs/5995eb9b-583c-4baf-9d6a-d269b793de6b/images/8746e8366c31acee5eaabd5b4adb5b22e015b5969a4b68c6acd1606cd74d6fbd.png",
    overview:
      "Expansion and retrofit steel scope for an operating industrial plant, executed under strict safety and production continuity constraints.",
    scope: [
      "Fabrication for retrofit tie-ins and new support structures",
      "Precision weld prep for constrained installation zones",
      "Staged delivery windows around active facility operations",
    ],
    highlights: [
      "Zero disruption to core production systems",
      "Safety-first execution through controlled sequencing",
      "Fabrication tolerances matched demanding retrofit conditions",
    ],
  },
  {
    slug: "memorial-district-mixed-use",
    title: "Memorial District Mixed-Use",
    sector: "Commercial + Residential",
    image:
      "https://images.pexels.com/photos/35383408/pexels-photo-35383408.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    overview:
      "Integrated steel package for a mixed-use development featuring commercial podium structures and upper-level residential framing components.",
    scope: [
      "Structural steel fabrication for podium and transfer levels",
      "Custom steel elements for architectural transitions",
      "Field support for multi-trade interface resolution",
    ],
    highlights: [
      "High-finish steelwork achieved across visible structural zones",
      "Strong cost discipline through fabrication planning",
      "Delivered exactly to engineered intent across all phases",
    ],
  },
];

export const galleryCategories = [
  "All",
  "Structural Steel Framing",
  "Commercial Developments",
  "Industrial Facilities",
  "Welding & Fabrication",
  "Custom Steel Installations",
];

export const galleryItems = [
  {
    title: "Primary Frame Assembly",
    category: "Structural Steel Framing",
    image:
      "https://static.prod-images.emergentagent.com/jobs/5995eb9b-583c-4baf-9d6a-d269b793de6b/images/235a1c00cec88bfca05fe7cc7014dd207138149d55506ef926c7ec4f0ceff346.png",
  },
  {
    title: "Plant Support Structure",
    category: "Industrial Facilities",
    image:
      "https://static.prod-images.emergentagent.com/jobs/5995eb9b-583c-4baf-9d6a-d269b793de6b/images/8746e8366c31acee5eaabd5b4adb5b22e015b5969a4b68c6acd1606cd74d6fbd.png",
  },
  {
    title: "Elevated Beam Welding",
    category: "Welding & Fabrication",
    image:
      "https://images.pexels.com/photos/14539147/pexels-photo-14539147.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    title: "Commercial Gridline Build",
    category: "Commercial Developments",
    image:
      "https://images.unsplash.com/photo-1646178829333-715fb0414823?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHx3ZWxkaW5nJTIwc3RlZWwlMjBiZWFtcyUyMGNvbnN0cnVjdGlvbiUyMHNpdGUlMjBpbmR1c3RyaWFsJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHxibGFja19hbmRfd2hpdGV8MTc3MzE1NTc0Nnww&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Precision Connection Plates",
    category: "Custom Steel Installations",
    image:
      "https://images.unsplash.com/photo-1606755767959-5e014ce90ad2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwzfHx3ZWxkaW5nJTIwc3RlZWwlMjBiZWFtcyUyMGNvbnN0cnVjdGlvbiUyMHNpdGUlMjBpbmR1c3RyaWFsJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHxibGFja19hbmRfd2hpdGV8MTc3MzE1NTc0Nnww&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Fabrication Floor Discipline",
    category: "Welding & Fabrication",
    image:
      "https://images.unsplash.com/photo-1709244596178-43f51715416d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxzdGVlbCUyMGNvbnN0cnVjdGlvbiUyMHdvcmtlcnMlMjB3ZWxkaW5nJTIwYmVhbXN8ZW58MHx8fHwxNzczMTU1NzU4fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Mixed-Use Steel Placement",
    category: "Commercial Developments",
    image:
      "https://images.pexels.com/photos/35383408/pexels-photo-35383408.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    title: "Structured Installation Sequence",
    category: "Structural Steel Framing",
    image:
      "https://images.unsplash.com/photo-1706067721099-025a4dbe7d3e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwzfHxzdGVlbCUyMGNvbnN0cnVjdGlvbiUyMHdvcmtlcnMlMjB3ZWxkaW5nJTIwYmVhbXN8ZW58MHx8fHwxNzczMTU1NzU4fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Custom Plate Work",
    category: "Custom Steel Installations",
    image:
      "https://images.unsplash.com/photo-1519143009590-e3800b9df468?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwyfHx3ZWxkaW5nJTIwc3RlZWwlMjBiZWFtcyUyMGNvbnN0cnVjdGlvbiUyMHNpdGUlMjBpbmR1c3RyaWFsJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHxibGFja19hbmRfd2hpdGV8MTc3MzE1NTc0Nnww&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Industrial Bay Precision",
    category: "Industrial Facilities",
    image:
      "https://static.prod-images.emergentagent.com/jobs/5995eb9b-583c-4baf-9d6a-d269b793de6b/images/2c0859068dcd0f03ecd1bfd66c09758b5264eca896d9b9672daa40a5738b1dee.png",
  },
];

export const qualityItems = [
  {
    title: "Cost Discipline",
    description: "Fabrication planning that protects budgets without compromising structural standards.",
  },
  {
    title: "Schedule Control",
    description: "Sequenced production and shipment workflows designed around real jobsite constraints.",
  },
  {
    title: "Fabrication Precision",
    description: "Detail-driven execution to ensure fit, alignment, and field readiness.",
  },
  {
    title: "Safety-First Culture",
    description: "Consistent safety practices embedded across shop operations and installation coordination.",
  },
  {
    title: "U.S. Standards Compliance",
    description: "Workflows aligned to U.S. construction quality and safety expectations.",
  },
];

export const openRoles = [
  "Structural Fabricator",
  "Certified Welder",
  "Project Manager",
  "Estimator",
];
